import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {AdminDashboardDrillDialogComponent} from './admin-dashboard-drill-dialog.component';
import {AdminDashboardDrillData, AdminDashboardDrillResult} from '@features/admin-panel/models/admin-dashboard-drill.models';

/**
 * The only way to open the Admin dashboard's drill dialog (ITP-E-159-03, Plan ITP-P-35 SPEC WEB-1): 760 px wide (the
 * mockup's Dialog maxWidth), focus on the dialog itself. Emits once when it closes: `{action: 'evidence', companyId}`
 * when the admin asked for the evidence of a company, undefined otherwise.
 */
@Injectable({providedIn: 'root'})
export class AdminDashboardDrillService {
  constructor(private dialog: MatDialog) {}

  open(data: AdminDashboardDrillData): Observable<AdminDashboardDrillResult | undefined> {
    return this.dialog.open<AdminDashboardDrillDialogComponent, AdminDashboardDrillData, AdminDashboardDrillResult>(
      AdminDashboardDrillDialogComponent, {width: '760px', autoFocus: 'dialog', data}
    ).afterClosed();
  }
}
